export const LAUNCH_TEST = 'LAUNCH_TEST';
export const TOGGLE_DARK_MODE='TOGGLE_DARK_MODE';
export const TOGGLE_PAUSE_MODAL='TOGGLE_PAUSE_MODAL';

export const DEACTIVATE_LOADING= 'DEACTIVATE_LOADING'


// EXAMEN

export const GET_EXAMEN='GET_EXAMEN';
export const GET_EXAMEN_ERROR='GET_EXAMEN_ERROR';
export const GET_EXAMEN_LOADING='GET_EXAMEN_LOADING';

// REVISION

export const GET_REVISION='GET_REVISION';
export const GET_REVISION_ERROR='GET_REVISION_ERROR';
export const GET_REVISION_LOADING='GET_REVISION_LOADING';

// CLICK IN ONE OF THE PROPOSITIONS
export const CLICK_QUESTION_OPTION='CLICK_QUESTION_OPTION';

// RIGHT ARROW OR 'SUIVANT' BUTTON
export const GO_NEXT_QUESTION_REVISION='GO_NEXT_QUESTION_REVISION';
// LEFT ARROW
export const GO_PREVIOUS_QUESTION_REVISION='GO_PREVIOUS_QUESTION_REVISION';

// SPACE OR 'VERIFIER LA REPONSE'
export const VERIFY_USER_ANSWER='VERIFY_USER_ANSWER'

// NAVIGATION IN PROGRESSION
export const GO_NTH_QUESTION_REVISION='GO_NTH_QUESTION_REVISION'
// 'EFFACER MA REPONSE'
export const DELETE_CHOOSEN_OPTIONS='DELETE_CHOOSEN_OPTIONS'
// TRUE = SPOILING THE CORRECTION
export const SET_VERIF_ANSWER_MODE_STATUS='SET_VERIF_ANSWER_MODE_STATUS'
// INCREMENT THE TIMER
export const INCREMENT_REVISION_TIMER='INCREMENT_REVISION_TIMER'
// SET CURRENT INTERVAL TIMER FOR THE REVISION
export const SET_INTERVAL_TIMER_REVISION='SET_INTERVAL_TIMER_REVISION'
// CLEAR REVISION INTERVAL TIMER
export const CLEAR_REVISION_INTERVAL_TIMER='CLEAR_REVISION_INTERVAL_TIMER'


// MULTI SELECT PAGE

//TAGS
export const GET_TAGS_LOADING='GET_TAGS_LOADING'
export const GET_TAGS='GET_TAGS'
export const GET_TAGS_ERROR='GET_TAGS_ERROR'

//MODULES
export const GET_MODULES_LOADING='GET_MODULES_LOADING'
export const GET_MODULES='GET_MODULES'
export const GET_MODULES_ERROR='GET_MODULES_ERROR'

// POST ANSWER REVISION

export const POST_ANSWER_REVISION='POST_ANSWER_REVISION';
export const POST_ANSWER_REVISION_CCQCM = 'POST_ANSWER_REVISION_CCQCM';
export const POST_ANSWER_REVISION_LOADING='POST_ANSWER_REVISION_LOADING';
export const POST_ANSWER_REVISION_ERROR = 'POST_ANSWER_REVISION_ERROR'

// FLAG QUESTION

export const FLAG_QUESTION_LOADING='FLAG_QUESTION_LOADING';
export const FLAG_QUESTION='FLAG_QUESTION';
export const FLAG_QUESTION_ERROR = 'FLAG_QUESTION_ERROR'

// PLAYLIST

export const  GET_PLAYLISTS_LOADING ='GET_PLAYLISTS_LOADING'
export const GET_PLAYLISTS='GET_PLAYLISTS'
export const GET_PLAYLISTS_ERROR='GET_PLAYLIST_ERROR'

export const CREATE_PLAYLIST_LOADING='CREATE_PLAYLIST_LOADING'
export const CREATE_PLAYLIST = 'CREATE_PLAYLIST'
export const CREATE_PLAYLIST_ERROR='CREATE_PLAYLIST_ERROR'

export const ADD_QUESTION_TO_PLAYLISTS_LOADING = 'ADD_QUESTION_TO_PLAYLISTS_LOADING'
export const ADD_QUESTION_TO_PLAYLISTS = 'ADD_QUESTION_TO_PLAYLISTS'
export const ADD_QUESTION_TO_PLAYLISTS_ERROR = 'ADD_QUESTION_TO_PLAYLISTS_ERROR'




//  BUILD QUIZ

export const POST_BUILD_QUIZ_LOADING='POST_BUILD_QUIZ_LOADING';
export const POST_BUILD_QUIZ_ERROR  ='POST_BUILD_QUIZ_ERROR';
export const POST_BUILD_QUIZ='POST_BUILD_QUIZ';



// RECAPITULATIF REVISION

export const SET_HOW_MANY_PAGINATION_BUTTONS_TO_CLICK='SET_HOW_MANY_PAGINATION_BUTTONS_TO_CLICK'


// CCQCM SPECIAL ACTIONS
export const GO_NTH_SUB_QUESTION = 'GO_NTH_SUB_QUESTION';
export const GO_NEXT_SUB_QUESTION= 'GO_NEXT_SUB_QUESTION';
export const CLICK_SUB_QUESTION_OPTION='CLICK_SUB_QUESTION_OPTION'

// AUTHENTIFICATION

export const LOGIN_USER_LOADING = 'LOGIN_USER_LOADING'
export const LOGIN_USER = 'LOGIN_USER';
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR'


// ADD COMMENT ( REVISION )

export const ADD_COMMENT_LOADING = 'ADD_COMMENT_LOADING';
export const ADD_COMMENT = 'ADD_COMMENT';
export const ADD_COMMENT_ERROR = 'ADD_COMMENT_ERROR';

// GET COMMENT (REVISION)

export const GET_COMMENT_LOADING = 'GET_COMMENT_LOADING';
export const GET_COMMENT = 'GET_COMMENT';
export const GET_COMMENT_ERROR = 'ADD_COMMENT_ERROR';
